import { router, addRoutes } from './router'
import { useStore } from '~/store'
import { getToken } from '~/utils/auth'
import nprogress from 'nprogress' // progress bar

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  nprogress.start()
  const store = useStore()
  const token = getToken()

  // 没有登录
  if (!token && to.path != '/login') {
    return next({ path: '/login' })
  }

  // 防止重复登录
  if (token && (to.path == '/login')) {
    return next({ path: from.path })
  }
  
  // 设置页面标题
  let title = (to.meta.title ? to.meta.title + '-' : "") + "林肯BM系统"
  document.title = title

  // 如果用户登录，获取登录信息
  let hasNewRoutes = false
  let hasGetInfo = false
  if (token && !hasGetInfo) {
    const data = await store.getMenu()
    await store.getUserInfo()
    await store.getNoticeCount()
    hasGetInfo = true
    // 动态添加路由
    hasNewRoutes = addRoutes(data)
  }
  hasNewRoutes ? next(to.fullPath) : next()
})

router.afterEach(() => {
  nprogress.done()
})
